// Module
var code = "<div class=\"dms-outer-element container-fluid\" style=\"padding:0\">\r\n    <div class=\"dms-grid-wrapper dms-grid dms-easy-edit #=data.GridName#\">\r\n    </div>\r\n</div>";
// Exports
export default code;